<template>
    <form id="AskAQuestionForm" @submit.prevent="submit" v-if="!success">
        <div class="form-group">
            <div class="form-check pt-0">
                <FormRadio :class="{'is-invalid': validationErrors.consulted_supervisor}" id="yes" value="1" v-model="form.consulted_supervisor"/>
                <FormLabel for="yes">I have consulted my leadership team prior to sending this request.</FormLabel>
            </div>
            <div class="form-check pt-0">
                <FormRadio :class="{'is-invalid': validationErrors.consulted_supervisor}" id="no" value="0" v-model="form.consulted_supervisor" />
                <FormLabel for="no">I have not consulted my leadership team.</FormLabel>
            </div>
            <ValidationError v-if="validationErrors.consulted_supervisor">{{ validationErrors.consulted_supervisor }}</ValidationError>
        </div>
        <div class="form-group">
            <FormLabel :required="true" for="first-name">First Name:</FormLabel>
            <FormInput :class="{'is-invalid': validationErrors.first_name}" id="first-name" v-model="form.first_name"/>
            <ValidationError v-if="validationErrors.first_name">{{ validationErrors.first_name }}</ValidationError>
        </div>
        <div class="form-group">
            <FormLabel :required="true" for="last-name">Last Name:</FormLabel>
            <FormInput :class="{'is-invalid': validationErrors.last_name}" id="last-name" v-model="form.last_name"/>
            <ValidationError v-if="validationErrors.last_name">{{ validationErrors.last_name }}</ValidationError>
        </div>
        <div class="form-group">
            <FormLabel :required="true" for="p-number">Pnumber (example P12345):</FormLabel>
            <FormInput :class="{'is-invalid': validationErrors.employee_id}" id="p-number" v-model="form.employee_id"/>
            <ValidationError v-if="validationErrors.employee_id">{{ validationErrors.employee_id }}</ValidationError>
        </div>
        <div class="form-group">
            <FormLabel :required="true" for="subject">Subject:</FormLabel>
            <FormInput :class="{'is-invalid': validationErrors.subject}" id="subject" v-model="form.subject"/>
            <ValidationError v-if="validationErrors.subject">{{ validationErrors.subject }}</ValidationError>
        </div>
        <div class="form-group">
            <FormLabel :required="true" for="message">Message:</FormLabel>
            <FormTextarea :class="{'is-invalid': validationErrors.message}" id="message" v-model="form.message"/>
            <ValidationError v-if="validationErrors.message">{{ validationErrors.message }}</ValidationError>
        </div>
        <div class="form-group d-flex align-items-sm-center justify-content-sm-between justify-content-lg-end flex-column flex-sm-row flex-sm-row-reverse">
            <p class="mb-3 mb-sm-0">Your leader will be cc’d in this communication.</p>
            <FormButton :pending="pending" pending-text="Submitting" class="mr-2">Submit</FormButton>
        </div>
        <div v-if="errorMessage" class="mt-3 alert alert-danger">
            <p class="mb-0">{{ errorMessage }}</p>
        </div>
    </form>
    <AskAQuestionConfirmation :question="form" v-else/>
</template>

<script>
import FormLabel from '@/components/form/FormLabel';
import FormInput from '@/components/form/FormInput';
import FormTextarea from '@/components/form/FormTextarea';
import ValidationError from '@/components/form/ValidationError';
import FormMixin from '@/mixins/FormMixin';
import FormButton from '@/components/form/FormButton';
import QuestionService from '@/services/question.service';
import AskAQuestionConfirmation from '@/components/global/AskAQuestionConfirmation';
import FormRadio from '@/components/form/FormRadio';

const EMPLOYEE = {
    first_name: '',
    last_name: '',
    employee_id: ''
};

const DEFAULT = {
    consulted_supervisor: '',
    first_name: '',
    last_name: '',
    employee_id: '',
    subject: '',
    message: ''
};

export default {
    props: {
        employee: {
            type: Object,
            default() {
                return EMPLOYEE;
            }
        }
    },
    components: {
        FormRadio,
        FormLabel,
        FormInput,
        FormTextarea,
        ValidationError,
        FormButton,
        AskAQuestionConfirmation
    },
    mixins: [
        FormMixin
    ],
    data() {
        return {
            form: {...DEFAULT, ...this.employee},
            success: false
        }
    },
    methods: {
        async submit() {
            if (this.pending) return;

            this.pending = true;
            this.errorMessage = '';
            this.validationErrors = {};

            try {
                await QuestionService.ask(this.form);
                this.success = true;
            } catch (error) {
                this.handleError(error);
            } finally {
                this.pending = false;
            }
        }
    }
}
</script>
